import { useIntl } from 'react-intl'

import { Badge } from '@gto/ui/badge'
import { Tooltip } from '@gto/ui/tooltip'

type StateDotProps = {
  on: boolean
  onLabelId: string
  offLabelId: string
  onTooltipId: string
  offTooltipId: string
}

/**
 * Boolean-state dot for table cells: green when on, red when off, with the
 * meaning carried by the tooltip and the accessible label (the dot alone is
 * colour-only). Renders the same `Badge variant="dot"` primitive as
 * `StatusBadge`, so every state circle in a row is visually identical.
 */
export const StateDot = ({
  on,
  onLabelId,
  offLabelId,
  onTooltipId,
  offTooltipId,
}: StateDotProps) => {
  const { formatMessage } = useIntl()

  const tooltip = formatMessage({ id: on ? onTooltipId : offTooltipId })
  const label = formatMessage({ id: on ? onLabelId : offLabelId })

  return (
    <Tooltip content={tooltip}>
      <span
        aria-label={label}
        className="inline-flex items-center"
        role="img"
      >
        <Badge
          color={on ? 'success' : 'error'}
          variant="dot"
        />
      </span>
    </Tooltip>
  )
}
